import { render } from "./DesignerHeader.vue?vue&type=template&id=0314996b&ts=true"
import script from "./DesignerHeader.vue?vue&type=script&lang=ts"
export * from "./DesignerHeader.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__